import { styled } from '@mui/material';
import { ContentRow, DetailsBody, DetailsPane } from '../../shared/detailsPaneStyles';

export const SentencesRoot = styled('div')({
  width: '100%',
  margin: 0,
  padding: 0,
  height: '100%',
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
});

export { ContentRow, DetailsPane, DetailsBody };
